"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var react_1 = __importDefault(require("react"));
var better_react_slick_1 = __importDefault(require("better-react-slick"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var NavigationButton_1 = __importDefault(require("./NavigationButton"));
var defaultSettings = {
    prevArrow: react_1.default.createElement(NavigationButton_1.default, { classes: "previous", ariaLabel: "previous" }),
    nextArrow: react_1.default.createElement(NavigationButton_1.default, { classes: "next", ariaLabel: "next" }),
    dots: false,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 6,
};
var Slider = function (props) {
    var children = props.children, className = props.className, settings = props.settings;
    var slickSettings = __assign(__assign({}, defaultSettings), settings);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('row container', className) },
        react_1.default.createElement(SliderWrapper, { className: "slider" },
            react_1.default.createElement(better_react_slick_1.default, __assign({}, slickSettings), children))));
};
exports.Slider = Slider;
var SliderWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .previous {\n    right: 30;\n  }\n\n  .next {\n    right: 0;\n  }\n\n  .slick-next,\n  .slick-prev {\n    background-color: ", ";\n\n    :hover {\n      background-color: ", ";\n    }\n  }\n\n  .slick-disabled {\n    background-color: ", ";\n  }\n"], ["\n  .previous {\n    right: 30;\n  }\n\n  .next {\n    right: 0;\n  }\n\n  .slick-next,\n  .slick-prev {\n    background-color: ", ";\n\n    :hover {\n      background-color: ", ";\n    }\n  }\n\n  .slick-disabled {\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.primary6; }, function (props) { return props.theme.primary3; }, function (props) { return props.theme.primary3; });
exports.default = exports.Slider;
var templateObject_1;
